import { FormattedMessage } from 'react-intl';
import { IconCloudOff } from '@rossum/ui/icons/tabler';
import { Link, Stack, SvgIcon, Typography } from '@rossum/ui/material';

type Props = {
  mail: string | null | undefined;
};

const IEView = ({ mail }: Props) => (
  <Stack alignItems="center" justifyContent="center" spacing={3}>
    <SvgIcon fontSize="xLarge">
      <IconCloudOff />
    </SvgIcon>
    <Typography variant="h5">
      <FormattedMessage id="containers.annotationList.upload.incompatible" />
    </Typography>
    {mail && (
      <FormattedMessage
        id="containers.annotationList.upload.email"
        values={{
          mail: (
            <Link href={`mailto:${mail || ''}`}>
              <strong>{mail}</strong>
            </Link>
          ),
        }}
      />
    )}
  </Stack>
);

export { IEView };
